module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallBlackH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallBlackH.svg
// module id = 259
// module chunks = 0